export function setTimeToDate(
  date: Date | string | null | undefined,
  hours: number,
  minutes: number
): Date | null | undefined {
  if (date === null || date === undefined) return date
  const d = new Date(date)
  d.setHours(hours)
  d.setMinutes(minutes)
  return d
}

export function formatReadableDate(date: string, { monthShort = false, noDay = false } = {}) {
  const d = new Date(date)
  const month = new Intl.DateTimeFormat('en-US', { month: monthShort ? 'short' : 'long' }).format(d)
  const day = d.getUTCDate()
  return noDay ? `${month} ${d.getFullYear()}` : `${month} ${day}, ${d.getFullYear()}`
}

export function formatReadableTime(date: string) {
  const d = new Date(date)
  const hour = d.getHours()
  const minute = d.getMinutes()
  const ampm = hour >= 12 ? 'PM' : 'AM'
  const timezone = Intl.DateTimeFormat('en-US', { timeZoneName: 'short' })
    .formatToParts(d)
    .find((part) => part.type === 'timeZoneName')?.value
  return `${hour % 12 || 12}:${minute < 10 ? `0${minute}` : minute} ${ampm} ${timezone}`
}
